export default {
  ativo: null,
  produto: [],
  itens: [],
  parcelas: [],
  selects: {
    parcelas: [
      { value: 2, text: "2X" },
      { value: 3, text: "3X" },
      { value: 4, text: "4X" },
      { value: 5, text: "5X" },
      { value: 6, text: "6X" },
      { value: 7, text: "7X" },
      { value: 8, text: "8X" },
      { value: 9, text: "9X" },
      { value: 10, text: "10X" }
    ]
  },
  form: {
    parcelas: [],
    parcela: "",
    qtde: "",
    tempo: 10,
    diautil: 26
  }
};
